module.exports = __webpack_public_path__ + "media/images/games/35gender/crying-d32d7157770d101c85ebdf675995300c.png";